import React, { useEffect } from 'react'
import { Container, Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { userManager } from 'utils/authHelpers'
import { FooterLoggedOut } from 'components/footer-blocks/footer-logged-out/FooterLoggedOut'
import { appRoutes } from 'constants/routes/appRoutes'
import { setFullMobileViewHeight } from 'utils/commonhelpers'
import { useLogoHelper } from 'utils/logoHelper'

import './LogoutCallbackPage.scss'
import appConfig from 'app.config'
import { createSearchParams } from 'react-router-dom'
import { CookieType } from 'constants/enums/cookieTypes'

function LogoutCallbackPage() {
	setFullMobileViewHeight()

	const { t } = useTranslation()
	const { whiteLogo } = useLogoHelper()

	const navigate = useNavigate()
	const [applicationId, setApplicationId] = React.useState<string>('')
	const [reason, setReason] = React.useState<string>('')

	useEffect(() => {
		userManager.signoutRedirectCallback().then((response) => {
			setApplicationId(response.state.applicationId)
			setReason(response.state.reason)
			const redirectUrl =
				sessionStorage.getItem(CookieType.RedirectUrl) ?? ''
			sessionStorage.clear()
			sessionStorage.setItem(CookieType.RedirectUrl, redirectUrl)
		})
		userManager.clearStaleState()
	}, [])

	return (
		<div id="logout-callback-page">
			<div className="background-img">
				<div className="logout-container">
					<Image
						src={whiteLogo}
						className="tfbank-logo logout"
						alt="TF Bank"
					/>
					<Container className="logout-body">
						<h2>
							{appConfig.country === 'de' && reason === 'idle'
								? t('LoggedOutIdle')
								: t('LoggedOut')}
						</h2>
						<button
							id="logout-callback-relogin-button"
							className="btn btn-outline-lightgray"
							onClick={() =>
								navigate({
									pathname: appRoutes.login,
									search: createSearchParams({
										applicationId: applicationId,
									}).toString(),
								})
							}>
							{t('Login')} <FontAwesomeIcon icon="sign-in-alt" />
						</button>
					</Container>
					<FooterLoggedOut />
				</div>
			</div>
		</div>
	)
}
export default LogoutCallbackPage
